import React, {Fragment, useContext, useEffect, useRef, useState} from "react";
import {Avatar, Button, Dropdown, Layout, Menu, MenuProps, Popconfirm, Spin} from "antd";
import styles from "./HeaderSearch.module.scss";
import {useTranslation} from "react-i18next";
import {AppContext} from "../../../pages/context/App.context";

import * as PropsUtil from "../../../props/util.props";
import {checkEmpty, logout, logoutCenter} from "src/service/util.service";
import chat_black from "src/assets/png/chat_blue.png";
import {chatContent} from "src/props/util.props";
import {NavLink, useNavigate} from "react-router-dom"
import {useDetectOutsideClick} from "./usedetectOutsideClick";
import CenterButton from "src/components/shared/button/CenterButton";
import {resetToken} from "src/service/auth.service";
import {settingIcon, settingPage} from "src/pages/Setting/setting.utils.props";
import {LoadingOutlined, PoweroffOutlined, UserOutlined} from "@ant-design/icons";
import Skeleton from "react-loading-skeleton";
import {useAppSelector} from "../../../hooks";
import {profile} from "../../../features/profile/profileSlice";
import {useMutation, useQueryClient} from "@tanstack/react-query";

const {Header, Footer, Sider, Content} = Layout;

const items: MenuProps['items'] = [
    {
        label: <a href="https://www.antgroup.com">1st menu item</a>,
        key: '0',
    },
    {
        label: <a href="https://www.aliyun.com">2nd menu item</a>,
        key: '1',
    },
    {
        type: 'divider',
    },
    {
        label: '3rd menu item',
        key: '3',
    },
];

function HeaderSearch(props: any) {
  const { t, i18n } = useTranslation();
  const appContext: any = useContext(AppContext);
  const [loading, setLoading]: any = useState(false);
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const logoutMutation = useMutation(logoutCenter, {
    // mutationKey: ["auth"],
    // onMutate: (variables) => {
    //   console.log("onMutate", variables);
    // },
    // onSuccess: (data, variables, context) => {
    //   console.log("onSuccess", data);
    //   // openNotificationWithIcon('success', t("Successfully delete post"), t(""));
    // },
    // onError: (error, variables, context) => {
    //   console.log("onError", error);
    //   // console.log("onError");
    //   // onError()
    //   // openNotificationWithIcon('error', t("Something wrong"), t("Can't delete post"));
    // },
    onSettled: (data, error, newPost) => {
      // console.log("logoutMutation", data);
      resetToken(false);
      queryClient.fetchQuery(['auth'])
      // setShowDeletePostModal(false);
      try {
        if(data?.loginType?.toLowerCase() === "azure"){
            window.location.href = `https://login.microsoftonline.com/${window.__RUNTIME_CONFIG__.REACT_APP_AZURE_LOGOUT_ID}/oauth2/logout?post_logout_redirect_uri=${window.__RUNTIME_CONFIG__.REACT_APP_MAIN_URL}`;
        }
      } catch (error) {
        console.error(error);
      };
    },
  })

    const myProfile = useAppSelector(profile);

    useEffect(() => {
        console.log("meto appContext:>", myProfile);
    }, []);

    const handleChatContent = () => {
        if (appContext.chatContent === chatContent.history) {
            if (!checkEmpty(appContext.activeChatId))
                appContext.setChatContent(chatContent.content);
        } else {
            appContext.setChatContent(chatContent.history);
        }
    };

    useEffect(() => {
        appContext.setChatContent(chatContent.history);
    }, []);

    const handleChatQuickContent = () => {
        navigate(PropsUtil.pathRoutes.Chat);
    };

    const handleProfile = () => {
        navigate(PropsUtil.pathRoutes.Profile)
    }
    const dropdownRef = useRef(null);
    const [isActive, setIsActive] = useDetectOutsideClick(dropdownRef, false);
    const onClickDropdownMenu = () => setIsActive(!isActive);

    useEffect(() => {
        const pageClickEvent = (e: any) => {
            console.log(e);
        };
        if (isActive) {
            window.addEventListener('click', pageClickEvent);
        }
        return () => {
            window.removeEventListener('click', pageClickEvent);
        }
    }, [isActive]);

    // const resetContext = () => {
    // console.log("==>",appContext.profile);
    // appContext.profile = null;
    // appContext.setProfile(null);
    // console.log("-->",appContext.profile);

    // };
    const logOut = async () => {
        logoutMutation.mutate();
        // try {
        //   console.log("try to logout");
        //   setLoading(true);
        //   appContext.setCallPayload(null);
        //   await logout();
        // } catch (e) {
        //   console.log("[resetToken]", e);
        // } finally {
        //   setLoading(false);
        //   resetToken(false);
        //   // resetContext();
        //   navigate(PropsUtil.pathRoutes.Root);
        // }
    };

    const antIcon = (
        <LoadingOutlined style={{fontSize: 24, color: "#FFFFFF"}} spin/>
    );


    const MenuItem = (item: any) => {
        return (
            <div
                className={styles.menuItemsContainer}
                onClick={() => {
                    navigate(PropsUtil.pathRoutes.Setting, {
                        state: {detail: item.target}
                    });
                    console.log(item.target);
                }}
            >
                {/* <div className={props.active ? styles.itemActive : ""} /> */}
                <div className={item.active ? styles.itemDetailActive : styles.itemDetail}>
                    {item.children}
                </div>
            </div>
        );
    };

    return (
        // null
        // <Spin indicator={antIcon} />
        <Header
            // hasSider={false}
            className={["site-layout-background", styles.overrideHeader].join(" ")}
            style={{padding: 0, width: "100vw", position: "fixed", zIndex: 99, top: 0}}
        >
            {/* HideNotComplete*/}
            {/*<Input*/}
            {/*  className={styles.searchBoxHeader}*/}
            {/*  placeholder={t("Search")}*/}
            {/*  prefix={<SvgSearchIcon width={12} height={12} color={"white"} />}*/}
            {/*  onChange={props.callbacksearch}*/}
            {/*  allowClear*/}
            {/*/>*/}
            {props.menu && (
                <div className={styles.extenalMenu}>
                    {props.menu}
                </div>
            )}
            <div style={{height: 50}}>
                {/* 111<audio id="audioE"></audio> */}
                    <Dropdown
                        overlay={
                            <Fragment>
                                <Menu
                                    style={{ width: 280 }}
                                    mode="inline"
                                >
                                    <div
                                        style={{display: "flex"}}
                                        className={styles.account}
                                        onClick={handleProfile}
                                    >
                                        <Avatar size={64} src={myProfile.imgURL} icon={<UserOutlined /> } />
                                        <div>
                                            <div
                                                className={styles.name}>
                                                {myProfile.name}
                                            </div>
                                            <div
                                                className={styles.username}>
                                                {myProfile.username}
                                            </div>
                                        </div>
                                    </div>
                                    <Menu.Item
                                        style={{paddingTop: ".5rem", paddingBottom: ".5rem" }}
                                        // style={{ minHeight: "30px"}}
                                        onClick={() => {
                                            navigate(PropsUtil.pathRoutes.Setting, {
                                                state: {detail: settingPage.GENERAL}
                                            });
                                        }}
                                    >
                                        <span style={{ marginLeft: "1rem" }}>{t("General")}</span>
                                    </Menu.Item>
                                    <Menu.Item
                                        style={{paddingTop: ".5rem", paddingBottom: ".5rem" }}
                                        onClick={() => {
                                            navigate(PropsUtil.pathRoutes.Setting, {
                                                state: {detail: settingPage.VERIFICATION}
                                            });
                                        }}
                                    >
                                        <span style={{ marginLeft: "1rem" }}>{t("Account Verifications")}</span>
                                    </Menu.Item>
                                    <Menu.Item
                                        style={{paddingTop: ".5rem", paddingBottom: ".5rem" }}
                                        onClick={() => {
                                            navigate(PropsUtil.pathRoutes.Setting, {
                                                state: {detail: settingPage.CHANGE_PASSWORD}
                                            });
                                        }}
                                    >
                                        <span style={{ marginLeft: "1rem" }}>{t("Change Password")}</span>
                                    </Menu.Item>
                                    <Menu.Item
                                        style={{paddingTop: ".5rem", paddingBottom: ".5rem" }}
                                        onClick={() => {
                                            navigate(PropsUtil.pathRoutes.Setting, {
                                                state: {detail: settingPage.GROUP_PREFERENCE}
                                            });
                                        }}
                                    >
                                        <span style={{ marginLeft: "1rem" }}>{t("Group Preferences")}</span>
                                    </Menu.Item>
                                    <Menu.Item
                                        style={{paddingTop: ".5rem", paddingBottom: ".5rem" }}
                                        onClick={() => {
                                            navigate(PropsUtil.pathRoutes.Setting, {
                                                state: {detail: settingPage.LANGUAGE}
                                            });
                                        }}
                                    >
                                        <span style={{ marginLeft: "1rem" }}>{t("Language and Region Settings")}</span>
                                    </Menu.Item>
                                    <Menu.Item
                                        style={{paddingTop: ".5rem", paddingBottom: ".5rem" }}
                                        onClick={() => {
                                            navigate(PropsUtil.pathRoutes.Setting, {
                                                state: {detail: settingPage.ABOUT}
                                            });
                                        }}
                                    >
                                        <span style={{ marginLeft: "1rem" }}>{t("About Software")}</span>
                                    </Menu.Item>
                                    <Menu.Item
                                        style={{paddingTop: ".5rem", paddingBottom: ".5rem" }}
                                        onClick={() => {
                                            navigate(PropsUtil.pathRoutes.Setting, {
                                                state: {detail: settingPage.REMOVE_ACCOUNT}
                                            });
                                        }}
                                    >
                                        <span style={{ marginLeft: "1rem" }}>{t("Remove account")}</span>
                                    </Menu.Item>
                                    {/*<Menu.Item>*/}
                                    {/*    <CenterButton*/}
                                    {/*        icon={<PoweroffOutlined/>}*/}
                                    {/*        loading={logoutMutation.isLoading}*/}
                                    {/*        disabled={loading}*/}
                                    {/*        onClick={logOut}*/}
                                    {/*    >*/}
                                    {/*        {t("Log out")}*/}
                                    {/*    </CenterButton>*/}
                                    {/*</Menu.Item>*/}
                                    <div style={{ display: "flex", justifyContent: "center", margin: ".5rem 0"}}>
                                        <CenterButton
                                            icon={<PoweroffOutlined/>}
                                            loading={logoutMutation.isLoading}
                                            disabled={loading}
                                            onClick={logOut}
                                        >
                                            {t("Log out")}
                                        </CenterButton>
                                    </div>
                                </Menu>
                                {/*<div>*/}
                                {/*    <CenterButton*/}
                                {/*        icon={<PoweroffOutlined/>}*/}
                                {/*        loading={logoutMutation.isLoading}*/}
                                {/*        disabled={loading}*/}
                                {/*        onClick={logOut}*/}
                                {/*    >*/}
                                {/*        {t("Log out")}*/}
                                {/*    </CenterButton>*/}
                                {/*</div>*/}
                            </Fragment>
                        }
                        // menu={{ items }}
                        trigger={['click']}>

                        {/*<div*/}
                        {/*    style={{*/}
                        {/*        // backgroundImage: `url(${myProfile.imgURL})`,*/}
                        {/*        float: "right",*/}
                        {/*        cursor: "pointer"*/}
                        {/*    }}*/}
                        {/*    className={styles.personalImg}*/}
                        {/*    // onClick={onClickDropdownMenu}*/}
                        {/*>*/}
                            <Avatar style={{
                                // backgroundImage: `url(${myProfile.imgURL})`,
                                float: "right",
                                cursor: "pointer"
                            }} className={styles.personalImg} size={40} src={myProfile.imgURL} icon={<UserOutlined /> } />
                        {/*</div>*/}
                        {/*<a onClick={(e) => e.preventDefault()}>*/}
                        {/*  <Space>*/}
                        {/*    Click me*/}
                        {/*    <DownOutlined />*/}
                        {/*  </Space>*/}
                        {/*</a>*/}
                    </Dropdown>

                <nav ref={dropdownRef}
                     className={`${styles.menu} ${isActive ? styles.active : styles.inactive}`}>
                    <ul>
                        <li
                            style={{display: "flex"}}
                            className={styles.account}
                            onClick={handleProfile}
                        >
                            {!myProfile.imgURL ? (
                                <div>
                                    <Skeleton
                                        count={1}
                                        style={{width: "70px", height: "70px", borderRadius: "50%"}}
                                    />
                                </div>
                            ) : (
                                <div>
                                    <div style={{backgroundImage: `url(${myProfile.imgURL})`}}
                                         className={styles.personalImage}>
                                    </div>
                                </div>)}
                            <div>
                                <div
                                    className={styles.name}>
                                    {myProfile.name}
                                </div>
                                <div
                                    className={styles.username}>
                                    {myProfile.username}
                                </div>
                            </div>
                        </li>
                        <li>
                            <MenuItem
                                target={settingPage.GENERAL}
                            >
                                {t("General")}
                            </MenuItem>
                        </li>
                        <li>
                            <MenuItem
                                target={settingPage.VERIFICATION}
                            >
                                {t("Account Verifications")}
                            </MenuItem>
                        </li>
                        <li>
                            <MenuItem
                                target={settingPage.CHANGE_PASSWORD}
                            >
                                {t("Change Password")}
                            </MenuItem>
                        </li>
                        <li>
                            <MenuItem
                                target={settingPage.GROUP_PREFERENCE}
                            >
                                {t("Group Preferences")}
                            </MenuItem>
                        </li>
                        <li>
                            <MenuItem
                                target={settingPage.LANGUAGE}
                            >
                                {t("Language and Region Settings")}
                            </MenuItem>
                        </li>
                        <li>
                            <MenuItem
                                target={settingPage.ABOUT}
                            >
                                {t("About Software")}
                            </MenuItem>
                        </li>
                        <li>
                            <MenuItem
                                target={settingPage.REMOVE_ACCOUNT}
                            >
                                {t("Remove account")}
                            </MenuItem>
                        </li>
                        <div>
                            <CenterButton
                                icon={<PoweroffOutlined/>}
                                loading={logoutMutation.isLoading}
                                disabled={loading}
                                onClick={logOut}
                            >
                                {t("Log out")}
                                {/*<div*/}
                                {/*  style={{*/}
                                {/*    display: "inline-flex",*/}
                                {/*    alignItems: "center",*/}
                                {/*    whiteSpace: "nowrap",*/}
                                {/*    verticalAlign:"middle"*/}
                                {/*  }}*/}
                                {/*>*/}
                                {/*  {loading ? <Spin indicator={antIcon} /> :  t("Log out")}*/}
                                {/*</div>*/}
                            </CenterButton>
                        </div>
                    </ul>
                </nav>
            </div>
            {props.isChat && (
                <div className={styles.chatMenu} onClick={handleChatContent}>
                    <div
                        style={{
                            backgroundImage: `url(${chat_black})`,
                        }}
                        className={styles.chatImg}
                    ></div>
                </div>
            )}
            {props.isQuickChat && (
                <div className={styles.chatMenu} onClick={handleChatQuickContent}>
                    <div
                        style={{
                            backgroundImage: `url(${chat_black})`,
                        }}
                        className={styles.chatImg}
                    ></div>
                </div>
            )}
        </Header>
    );
}


export default HeaderSearch;
